<template>
    <div class="compare-monthly-graph">
        <div class="container-width">
            <h2 class="section-title">Compare Monthly Payments by Loan Term</h2>
            <div class="payment-chart">
                <div class="compare-bar-chart">
                    <div>
                        <vue-chart
                            :data="chartData"
                            :height="ChartHeight"
                            :options="chartOptions"
                            :width="ChartWidth"
                            type="bar"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueChart from 'vue-chart-js';
    import Accounting from 'accounting';

    export default {
        props: {
            paymentData: {
                type: Object,
                default() {
                    return {
                        rates: [2201.53, 1114.51, 752.24, 571.17, 462.57, 390.21],
                    };
                },
            },
        },
        data() {
            return {
                PaymentData: this.paymentData,
                ChartWidth: 1140,
                ChartHeight: 270,
                chartData: {
                    labels: ['12 months', '24 months', '36 months', '48 months', '60 months', '72 months'],
                    datasets: [{
                        data: this.paymentData.rates,
                        label: 'Payment',
                        backgroundColor: '#99dff9',
                        borderColor: '#99dff9',
                        hoverBackgroundColor: '#00aeef',
                        hoverBorderColor: '#00aeef',
                        borderWidth: 3,
                        fill: false,
                        borderJoinStyle: 'round',
                        categoryPercentage: 0.4,
                    }],
                },
                chartOptions: {
                    animation: {
                        duration: 1000,
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                padding: 10,
                            },
                            gridLines: [{
                                display: false,
                            }],
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                callback(value, index, values) {
                                    if (Math.max(...values) <= 10) {
                                        return `$${Accounting.formatNumber(value, { precision: 2 })}`;
                                    }
                                    return `$${Accounting.formatNumber(value)}`;
                                },
                            },
                        }],
                    },
                    tooltips: {
                        enabled: false,
                        custom(tooltip) {
                            let tooltipEl = document.getElementById('chartjs-tooltip-payoff');
                            if (!tooltipEl) {
                                tooltipEl = document.createElement('div');
                                tooltipEl.id = 'chartjs-tooltip-payoff';
                                tooltipEl.innerHTML = '<div></div>';
                                this._chart.canvas.parentNode.appendChild(tooltipEl);
                            }
                            if (tooltip.opacity === 0) {
                                tooltipEl.style.opacity = 0;
                                return;
                            }
                            tooltip.displayColors = false;
                            tooltipEl.classList.remove('above', 'below', 'no-transform');
                            if (tooltip.yAlign) {
                                tooltipEl.classList.add(tooltip.yAlign);
                            } else {
                                tooltipEl.classList.add('no-transform');
                            }
                            function getBody(bodyItem) {
                                return bodyItem.lines;
                            }
                            // Set Text
                            if (tooltip.body) {
                                let innerHtml = '';
                                const titleLines = tooltip.title || [];
                                const bodyLines = tooltip.body.map(getBody);
                                titleLines.forEach((title) => {
                                    innerHtml += `<label>${title}</label>`;
                                });
                                bodyLines.forEach((body) => {
                                    const bodaySplit = body[0].split(':');
                                    innerHtml += `<label>${bodaySplit[0]}: <b>$${Accounting.formatNumber(bodaySplit[1], { precision: 2 })}</b></label>`;
                                });
                                const tableRoot = tooltipEl.querySelector('div');
                                tableRoot.innerHTML = innerHtml;
                            }
                            const positionY = this._chart.canvas.offsetTop;
                            const positionX = this._chart.canvas.offsetLeft;
                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
                            tooltipEl.style.top = `${positionY - 60 + tooltip.caretY}px`;
                            tooltipEl.style.height = '53px';
                        },
                    },
                },
            };
        },
        methods: {
            pushDataInChart() {
                this.$set(this.chartData, 'labels', ['12 months', '24 months', '36 months', '48 months', '60 months', '72 months']);
                this.$set(this.chartData, 'datasets', []);
                this.chartData.datasets.push({
                    data: this.paymentData.rates,
                    label: 'Payment',
                    backgroundColor: '#c2e8de',
                    borderColor: '#c2e8de',
                    hoverBackgroundColor: '#08c177',
                    hoverBorderColor: '#08c177',
                    borderWidth: 3,
                    fill: false,
                    borderJoinStyle: 'round',
                    categoryPercentage: 0.4,
                });
            },
        },
        mounted() {
            this.pushDataInChart();
        },
        watch: {
            PaymentData: {
                handler() {
                    this.pushDataInChart();
                },
                deep: true,
            },
        },
        components: {
            VueChart,
        },
        mixins: [Accounting],
    };
</script>

<style lang="scss">
@import "../../../assets/styles/variables";

#lt-yantr {
    .compare-monthly-graph {
        text-align: center;
        margin-top: 50px;

        @media #{$mob-landscape-view} {
            margin-top: 30px;
        }

        .section-title {
            margin-bottom: 0;

            @media #{$mob-landscape-view} {
                font-weight: 600;
                line-height: normal;
            }
        }

        .payment-chart {
            .compare-bar-chart {
                position: relative;
                padding-top: 30px;

                @media #{$mob-landscape-view} {
                    overflow-y: hidden;

                    & > div {
                        width: 767px;
                    }
                }

            }
        }

        #chartjs-tooltip-payoff {
            width: auto;
            padding: 7px 14px;
            white-space: nowrap;

            label {
                font-size: 13px;
                display: block;
                margin-bottom: 0;
            }
        }
    }
}
</style>
